export default __webpack_public_path__ + "static/media/watson-8.a83ad170.png";